import { invokeApi } from "src/utils";
export const getAllTeamMembersList = async (page, rows, search, status) => {
  const requestObj = {
    path: `api/employee/get_employees?search=${search}&active_status=${status}&page=${page}&limit=${rows}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const getAllTeamMembersListNew = async (
  page,
  rows,
  search,
  status,
  filters,
) => {
  const requestObj = {
    path: `api/employee/get_employees_v1?search=${search || ""}&active_status=${
      status == "all" ? "" : status == "active" ? "active" : "inactive"
    }&page=${page}&limit=${rows}${
      filters?.company?._id ? `&company_id=${filters?.company?._id}` : ""
    }&employee_status=${!filters?.employment_status || filters?.employment_status == "all" ? "" : filters?.employment_status}${
      filters?.tech_lead?.user_id
        ? `&tech_lead=${filters?.tech_lead?.user_id}`
        : ""
    }${filters?.sub_lead?.user_id ? `&leads=${filters?.sub_lead?.user_id}` : ""}${
      filters?.salary_min ? `&min_salary=${filters?.salary_min}` : ""
    }${filters?.salary_max ? `&max_salary=${filters?.salary_max}` : ""}${
      filters?.date_from ? `&start_date=${filters?.date_from}` : ""
    }${filters?.date_to ? `&end_date=${filters?.date_to}` : ""}${
      filters?.blood_group && filters?.blood_group !== "all"
        ? `&blood_group=${filters?.blood_group}`
        : ""
    }${filters?.salary_transfer_method && filters?.salary_transfer_method !== "all" ? `&salary_transfer_method=${filters?.salary_transfer_method}` : ""}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const getTeamMemberDetail = async (id) => {
  const requestObj = {
    path: `api/employee/detail_employee_by_id/${id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const _detail_employee_by_id_for_settings = async (id) => {
  const requestObj = {
    path: `api/employee/detail_employee_by_id_for_settings/${id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const _detail_employee_by_id_popup = async (id) => {
  const requestObj = {
    path: `api/employee/detail_employee_by_id_popup/${id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const addTeamMember = async (data) => {
  const requestObj = {
    path: `api/employee/add_employee`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const editTeamMembers = async (_id, data) => {
  const requestObj = {
    path: `api/employee/edit_employee/${_id}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
export const editTeamMembersBoardingStatus = async (_id, data) => {
  const requestObj = {
    path: `api/employee/update_employee_status/${_id}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
export const _edit_employee_for_settings = async (_id, data) => {
  const requestObj = {
    path: `api/employee/edit_employee_for_settings/${_id}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const deleteTeamMember = async (_id) => {
  const requestObj = {
    path: `api/employee/delete_employee/${_id}`,
    method: "DELETE",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const addTeamMemberToDeactiveList = async (data) => {
  const requestObj = {
    path: `api/employee_deactivation/add_employee_deactivation`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
export const getTeamMemberAttendance = async (data) => {
  const requestObj = {
    path: `api/attendance/get_attendance_for_employee`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
export const getTeamMembersWithoutSearch = async (data) => {
  const requestObj = {
    path: `api/employee/get_all_employees`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const getTeamMembersWithoutSearchAndInActiveMembers = async (
  companyId = "",
) => {
  const requestObj = {
    path: `api/employee/get_active_employees${companyId ? `?company_id=${companyId}` : ""}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const _get_member_list_for_my_team = async () => {
  const requestObj = {
    path: `api/employee/get_member_list_for_my_team`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const _get_active_employees_for_loan = async (value) => {
  const requestObj = {
    path: `api/employee/get_active_employees_for_loan?search=${value}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const markAsDiscount = async (data) => {
  const requestObj = {
    path: `api/attendance/mark_discount_minutes`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
export const getAbsentsDetails = async (page, rows, data) => {
  const requestObj = {
    path: `api/attendance/get_employee_absents?page=${page}&limit=${rows}`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
export const _get_employee_leaves = async (page, rows, data) => {
  const requestObj = {
    path: `api/attendance/get_employee_leaves?page=${page}&limit=${rows}`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const _get_data_for_add_employee = async () => {
  const requestObj = {
    path: `api/dashboard/get_data_for_add_employee`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const _list_increment_history = async (data) => {
  const requestObj = {
    path: `api/increment_history/list_increment_history`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const _add_increment_history = async (data) => {
  const requestObj = {
    path: `api/increment_history/add_increment_history`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
export const _update_increment_history = async (_id, data) => {
  const requestObj = {
    path: `api/increment_history/update_increment_history/${_id}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const _change_leave_payment_status = async (_id, data) => {
  const requestObj = {
    path: `api/leave_request/change_leave_payment_status/${_id}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const _update_count_in_yearly_leaves = async (_id, data) => {
  const requestObj = {
    path: `api/leave_request/update_count_in_yearly_leaves/${_id}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const _delete_increment_history = async (_id) => {
  const requestObj = {
    path: `api/increment_history/delete_increment_history/${_id}`,
    method: "DELETE",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const _get_employee_allowance = async (id) => {
  const requestObj = {
    path: `api/employee/get_employee_allowance/${id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
